import { ProcedureType } from "api/type";

// TODO: These there fuctions are not completely implemented
export const isFaceProcedure = (procedure: ProcedureType) => {
  return [
    ProcedureType.LIP_FILLER,
    ProcedureType.RHINOPLASTY,
    ProcedureType.OTOPLASTY,
    ProcedureType.FOREHEAD_LIFT,
    ProcedureType.CHIN_SURGERY,
    ProcedureType.BURN_REPAIR,
    ProcedureType.RECONSTRUCTIVE_SURGERY,
    ProcedureType.SCAR_REVISION,
    ProcedureType.HAIR_TRANSPLANTATION,
    ProcedureType.LASER_TREATMENTS,
    ProcedureType.CHEMICAL_PEEL,
    ProcedureType.MICRODERMABRASION,
    ProcedureType.LASER_HAIR_REMOVAL,
    ProcedureType.BLEPHAROPLASTY,
    ProcedureType.RHYTIDECTOMY,
    ProcedureType.CHEEK_AUGMENTATION,

    ProcedureType.HAIR_TRANSPLANT,
    ProcedureType.BIOCHETOMY,
    ProcedureType.FACE_LIFT,
    ProcedureType.CHIN_IMPLANT,
  ].includes(procedure);
};

export const isBodyProcedure = (procedure: ProcedureType) => {
  return [
    ProcedureType.BBL,
    ProcedureType.TUMMY_TUCK,
    ProcedureType.LIPOSUCTION,
    ProcedureType.RENUVION,
    ProcedureType.ABDOMINAL_ETCHING,
    ProcedureType.THIGH_LIPOSUCTION,
    ProcedureType.ARMS_LIPOSUCTION,
    ProcedureType.CHIN_LIPOSUCTION,
    ProcedureType.LABIAPLASTY,
    ProcedureType.VAGINAL_TIGHTENING,
    ProcedureType.VAGINAL_PRP,
  ].includes(procedure);
};

export const isTorsoProcedure = (procedure: ProcedureType) => {
  return [
    ProcedureType.BREAST_LIFT,
    ProcedureType.BREAST_REDUCTION,
    ProcedureType.BREAST_AUGMENTATION,
    ProcedureType.BREAST_LIFT_AND_AUGMENTATION,
    ProcedureType.LIPOSUCTION,
  ].includes(procedure);
};
